const route_regex = (expression) =>
  new RegExp(`^/(${window.gon.available_locales.join("|")})${expression}`, "i")

export default route_regex
